import { render } from "./PaneUnit.vue?vue&type=template&id=0c4d6362&scoped=true&ts=true"
import script from "./PaneUnit.vue?vue&type=script&lang=ts"
export * from "./PaneUnit.vue?vue&type=script&lang=ts"

import "./PaneUnit.vue?vue&type=style&index=0&id=0c4d6362&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4d6362"]])

export default __exports__